import React, { useState } from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useClientOrders, useRepeatOrder } from "@/hooks/domain/order";
import { Order } from "@/interfaces/domain/Order";
import { OrderNavigation } from "@/navigation/stacks/OrderStack";

import OrderDetailsModal from "../components/OrderDetailsModal";
import OrderListMobile from "./OrderList.mobile";
import OrderListWeb from "./OrderList.web";

const Orders = () => {
  const { isWebMode } = useViewport();
  const { navigate, goBack } = useAppNavigation<OrderNavigation>();
  const { repeatOrder } = useRepeatOrder();

  const { data: orders, isLoading, hasNextPage, fetchNextPage } = useClientOrders();

  const [selectedOrder, setSelectedOrder] = useState<Order>();

  const onSelectOrder = (orderId: string) => {
    navigate("orderTracking", {
      orderId,
    });
  };

  const onLoadMore = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const Screen = isWebMode ? OrderListWeb : OrderListMobile;

  return (
    <>
      <Screen
        orders={orders}
        isLoading={isLoading}
        onGoBack={goBack}
        onLoadMore={onLoadMore}
        onSelectOrder={onSelectOrder}
        onPressRepeatOrder={(order) => setSelectedOrder(order)}
      />
      {selectedOrder && (
        <OrderDetailsModal
          isOpen={!!selectedOrder}
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
          onPressRepeatOrder={() => {
            repeatOrder(selectedOrder);
            setSelectedOrder(null);
          }}
        />
      )}
    </>
  );
};

export default Orders;
